module.exports = __webpack_public_path__ + "static/media/w-2_08.7f5a56fd.png";